export const translationsFrFR = {
  "generic.language.english": "Anglais",
  "generic.language.french": "Français",
  "generic.connect.google": "Se connecter avec Google",
  "generic.button.title.save": "Sauvegarder",
  "generic.crud.create.cta": "Créer",
  "generic.use.none": "Aucun",
  "generic.use.next": "Suivant",
  "generic.dataType.string": "chaine de caractères",
  "generic.dataType.string.developped":
    "Tous textes, mots divers du langage, lien URL...",
  "generic.dataType.boolean": "vrai/faux",
  "generic.dataType.boolean.developped":
    "donnée qui ne peut être que vraie ou fausse, ou oui/non",
  "generic.dataType.number": "chiffres & nombres",
  "generic.dataType.number.developped":
    "données de type chiffre ou nombre. Ne peut contenir de texte.",
  "generic.dataType.date": "dates",
  "generic.dataType.date.developped":
    "tout types de date, contenant au minimum l'année.",
  "generic.dataType.enum": "liste définie",
  "generic.dataType.enum.developped":
    "liste de valeurs possibles qui sont connues à l'avance",
  "generic.form.dropdown.placeholder": "Choisir ...",
  "generic.save": "Sauvegarder",
  "generic.notification.error":
    "Il y a eu une erreur. Merci de réessayer ultérieurement.",
  "generic.notification.error.showMessage":
    "Il y a eu une erreur pendant cette opération. Erreur log :",
  "generic.contactUs.calendly": "Réserver une démo",

  "site.global.tabTitle":
    "Chatsystem.ai | L'agent de vente pour votre site e-commerce",
  "site.global.description":
    "Servez vos utilisateurs avec les meilleurs conseils d'IA",

  "pagination.previous": "Précédent",
  "pagination.next": "Suivant",

  "textarea.placeholder.nonBoolean.semanticDescription":
    "Ex: La taille des chaussures",
  "textarea.placeholder.boolean.semanticDescription":
    "Ex: Ce plat est-il sans gluten ?",
  "textarea.errorMessage.minLength0":
    "Cette phrase est très importante pour aider le robot à analyser ce que lui demande lui client.",
  "textarea.errorMessage.shouldEndWithQuestionMark":
    "En cas de colonne vrai/faux, votre description doit être une question. Exemple : Ce plat est-il végétarien ? La phrase doit finir par un point d'interrogation.",
  "input.placeholder.columnName": "Ex: Type de jeux de société",
  "input.errorMessage.minLength0":
    "Ce champs est obligatoire pour que le robot comprenne de quoi cette donnée traite. Donnez un nom simple qu'un ami comprendrait.",

  "page.login.button.login": "Se connecter / S'inscrire",
  "page.login.google.login": "Continuer avec Google",

  "navbar.button.home": "Accueil",
  "navbar.button.pricing": "Tarifs",
  "navbar.button.login": "Se Connecter",
  "navbar.button.demo": "Demo",
  "navbar.userMenu.logout": "Déconnection",
  "navbar.userMenu.profile": "Profil",
  "navbar.userMenu.admin": "Admin",
  "navbar.userMenu.backOffice": "Back-office",

  "home.header.catchphase": "Enfin un chatbot intelligent",
  "home.header.subcatchphase":
    "Découvrez le chatbot qui connait vos produits sur le bout des doigts",
  "home.header.CTA": "Voir notre solution",
  "home.section.bulletsPointParagraphe1.title": "Pertinent",
  "home.section.bulletsPointParagraphe1.text":
    "Fait les meilleures recommandations de produits basé sur votre stock et la demande du client",
  "home.section.bulletsPointParagraphe2.title": "A l'écoute",
  "home.section.bulletsPointParagraphe2.text":
    "Comprend réellement vos clients et leur intention d'achat avant de leur répondre",
  "home.section.bulletsPointParagraphe3.title": "Flexible",
  "home.section.bulletsPointParagraphe3.text":
    "S'ajuste aux demandes des clients pour apporter une réponse toujours adaptée",

  "home.realm.title": "La nouvelle génération d'intelligence artificielle",
  "home.realm.text":
    "Les nouvelles technologies d'IA permettent une révolution du comportement des agents automatisés. Notre chatbot est construit sur ce pillier fort qui ouvre de nouvelles perspectives d'usage pour les clients",
  "home.realm.cta": "Testez notre solution",
  "home.realm.secondary.title": "Aidez vos clients en permanence",
  "home.realm.secondary.text":
    "7 jours sur 7, 24 heures sur 24, le chatbot donne des conseils de qualité à tous vos clients. C'est un excellent soutien aux vendeurs.",
  "home.realm.secondary.cta": "Découvrez notre solution",
  "home.testimonials.title": "Nos clients parlent de nous",
  "home.testimonials.1.text":
    "Depuis notre utilisation du logiciel, nous avons un meilleur contrôle du flux de marchandises et un suivi de performance pertinent.",
  "home.testimonials.1.job": "Developpeur @Wordpress",
  "home.testimonials.1.name": "Loic Martins",
  "home.testimonials.2.text":
    "La mise en production de la solution logicielle nous a permis de réorganiser complètement les équipes.",
  "home.testimonials.2.job": "Community Manager @Comet",
  "home.testimonials.2.name": "Anna Wang",
  "home.testimonials.3.text":
    "La maitrise du sujet logistique est une évidence avec la solution logicielle.",
  "home.testimonials.3.job": "Product Owner @April",
  "home.testimonials.3.name": "Louis Bachant",
  "home.test.section.title": "Testez dès maintenant",
  "home.book.section.title": "Voir dès maintenant",
  "home.test.section.CTA": "Voir notre solution",

  "article.doesntExist":
    "Cet article n'existe pas. Merci de revenir à la page d'accueil.",

  "pricing.CTA.pleaseLogin": "Connectez-vous",
  "pricing.page.title": "Choisissez votre plan",
  "pricing.page.plan.highlight": "POPULAIRE",
  "pricing.page.subtitle":
    "Sans engagement : annulez à tout moment en un clic.",
  "pricing.page.buttonText.buy": "Acheter",
  "pricing.page.buttonText.YouAlreadyHaveIt": "Votre formule actuelle",
  "pricing.page.formula.feature.alreadySubbed": "Vous êtes déjà abonné !",
  "pricing.page.formulaName.fixedIncreasable": "Fixe renouvelable",
  "pricing.page.formulaName.fixedPlusDynamic": "Fixe + Variable",
  "pricing.page.formulaName.fullDynamic": "Complètement variable",
  "pricing.page.formulaName.fullFixed": "Fixe cappé",
  "pricing.page.formulaName.custom": "Sur mesure",
  "pricing.page.buttonText.contactUs": "Contactez-nous",
  "pricing.page.formula.feature.botAccess": "Accès Chatbot",
  "pricing.page.formula.feature.limitedAccess": "Accès limité",
  "pricing.page.formula.feature.unlimitedAccess": "Accès illimité",
  "pricing.page.formula.feature.userFollowUp":
    "Suivi des discussions utilisateurs",
  "pricing.page.formula.feature.useAtscale": "Utilisation à grande échelle",

  "subscribe.paymentRecap.title": "Récapitulatif de paiement",
  "subscribe.paymentRecap.customerName": "Nom",
  "subscribe.paymentRecap.customerMail": "Email",
  "subscribe.paymentRecap.additionnalMention": "Mention à ajouter",
  "subscribe.paymentRecap.totalAmount": "Total",
  "subscribe.paymentForm.title": "Carte bancaire",
  "subscribe.paymentForm.cardNumber": "Numéro de carte",
  "subscribe.paymentForm.expiresAt": "Expire le",
  "subscribe.paymentForm.CVCNumber": "Numéro CVV",
  "subscribe.paymentForm.CTA.loading": "Chargement ...",
  "subscribe.paymentForm.CTA.pay": "S'abonner",

  "subscribe.success.title": "Paiement effectué avec succès",
  "subscribe.success.paragraph1":
    "Votre paiement a bien été accepté. Vous êtes désormais abonné !",
  "subscribe.success.paragraph2":
    "Toutes vos options sont maintenant disponibles.",

  "myAccount.page.leftMenu.general": "Général",
  "myAccount.page.leftMenu.profile": "Profil",
  "myAccount.page.leftMenu.setup": "Installation",
  "myAccount.page.leftMenu.upload": "Uploader Produits",
  "myAccount.page.leftMenu.myCatalogs": "Mes Catalogues",
  "myAccount.page.leftMenu.myAgents": "Mes Agents",
  "myAccount.page.leftMenu.myDNS": "Mes noms de domaine autorisés",
  "myAccount.page.leftMenu.sessions": "Discussions utilisateurs",
  "myAccount.page.leftMenu.testMyChatbot": "Tester mon Chatbot",
  "myAccount.page.leftMenu.settings": "Paramètres",
  "myAccount.page.leftMenu.devSpace": "Espace Developpeur",
  "myAccount.page.subscriptionFormulas.title": "Formules Abonnements",
  "myAccount.page.setup.title": "Installation",
  "myAccount.page.setup.client": "Client",
  "myAccount.page.setup.api": "Api",
  "myAccount.page.setup.jwt.description": "Votre JWT pour contacter l'api: ",
  "myAccount.page.setup.jwt.copyClipboard": "JWT copié !",
  "myAccount.page.sesstions.title": "Discussions Utilisateurs",

  "myAccount.page.setup.subscribe":
    "Abonnez-vous pour accéder à votre appToken et pouvoir utiliser l'application.",
  "myAccount.page.setup.appTokenIs": "Votre appToken est",
  "myAccount.page.setup.copySnippetWidget":
    "Copiez ce code dans votre index.html :",
  "myAccount.page.setup.copySnippetReact":
    "Importez l'app React en haut de votre arbre, avec la prop AppToken comme suit :",

  "myAccount.page.setup.documentation.title": "Documentation",
  "myAccount.page.setup.documentation.documentationExplaination":
    "La documentation est disponible sur ce ",
  "myAccount.page.setup.documentation.documentationExplaination.link": "lien",
  "myAccount.page.setup.documentation.swaggerExplaination":
    "Le swagger est disponible sur ce ",
  "myAccount.page.setup.documentation.swaggerExplaination.link": "lien",

  "myAccount.page.upload.title": "Uploadez vos produits",
  "myAccount.page.upload.uploadFile.explaination":
    "Merci de choisir un fichier CSV ou XLSX comportant vos produits.",
  "myAccount.page.upload.uploadFile.noFile": "Aucun fichier n'a été uploadé.",
  "myAccount.page.upload.catalogSelection.dropdown.explaination":
    "Choisissez un catalogue dans lequel télécharger vos produits. Vous pouvez créer un catalogue à partir d'un fichier ou télécharger des produits sur un catalogue existant.",
  "myAccount.page.upload.catalogSelection.dropdown.placeholder":
    "Choisissez un catalogue",
  "myAccount.page.upload.catalogSelection.dropdown.addNew":
    "Créer un nouveau catalogue",

  "myAccount.page.upload.MandatoryColumns.title":
    "Colonnes obligatoires pour le robot",
  "myAccount.page.upload.MandatoryColumns.explaination":
    "Afin de bien construire les messages de réponses au client, nous avons besoin de connaître spécifiquement les colonnes suivantes parmi votre fichier. Ces colonnes sont obligatoires pour que le retour du robot soit au niveau de qualité attendu.",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.description":
    "Description",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.description.details":
    "Indiquez la colonne contenant la description du produit. Plus la description est détaillée, meilleure sera la recherche.",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.doesNotExist":
    "N'existe pas dans ce fichier",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.productName.fr":
    "Product Name FR",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.productName.fr.details":
    "Indiquez la colonne contenant le nom FRANCAIS de votre produit. C’est le nom qui sera affiché dans le tchat quand votre produit sera conseillé par le robot. Seule une langue est obligatoire pour les noms de produits.",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.productName.en":
    "Product Name EN",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.productName.en.details":
    "Indiquez la colonne contenant le nom ANGLAIS de votre produit. C’est le nom qui sera affiché dans le tchat quand votre produit sera conseillé par le robot. Seule une langue est obligatoire pour les noms de produits.",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.sellingPrice":
    "Prix de vente",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.sellingPrice.details":
    "Indiquez la colonne contenant le prix du produit. C’est le prix qui sera indiqué dans le tchat lorsque le produit sera conseillé.",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.urlProduct":
    "URL du produit",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.urlProduct.details":
    "Indiquez la colonne contenant l’URL de la fiche du produit. C’est l’URL qui servira à rediriger l’utilisateur quand il cliquera sur le produit dans le tchat.",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.imageSrc":
    "URL de l'image du produit",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.imageSrc.details":
    "Indiquez la colonne contenant l’URL de l'image du produit. Cette image sera affichée dans le résultat du tchat.",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.customerProductId":
    "ID unique du produit",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.customerProductId.details":
    "Indiquez la colonne contenant l'ID du produit. Cet ID doit être unique pour chaque produit.",
  "myAccount.page.upload.MandatoryColumns.validation.cta": "Ok",

  "myAccount.page.upload.columnSearchSelection.introduction":
    "Quelles colonnes souhaitez-vous utiliser pour filtrer les produits pour vos clients ? Choisissez celles qui font sens, qui définissent votre produit, sur lesquelles une recherche peut être effectuée.",
  "myAccount.page.upload.columnSearchSelection.title":
    "Sélection des colonnes utiles",

  "myAccount.page.upload.mandatoryColumns.title":
    "Selection de colonnes obligatoires",
  "myAccount.page.upload.mandatoryColumns.explanaition":
    "Parmi les critères de recherche, est-ce qu'un critère est obligatoire pour proposer des produits à vos clients ? Par exemple, pour conseiller un jeu de société à un client, l'âge est très important: pour un enfant on ne conseille pas le même jeu qu'à un adulte !",
  "myAccount.page.upload.mandatoryColumns.explanaition.two":
    "Si vous cochez une case ici, le robot demandera cette information au client.",
  "myAccount.page.upload.mandatoryColumns.maximumSelection":
    "Merci de choisir 3 catégories obligatoires maximum.",

  "myAccount.page.upload.columnDefinition.title":
    "Expliquez vos données au robot",
  "myAccount.page.upload.columnDefinition.explaination.danger":
    "Le robot a besoin de comprendre quelle donnée il parcourt. Cette étape est très importante pour la compréhension des produits de votre catalogue.",
  "myAccount.page.upload.columnDefinition.explaination.guidelines.list.name":
    "Donnez des noms faciles à comprendre",
  "myAccount.page.upload.columnDefinition.explaination.guidelines.list.dataType":
    "Précisez le type de donnée pour que le robot sache comment la parcourir",
  "myAccount.page.upload.columnDefinition.explaination.guidelines.list.semanticDescription":
    "Expliquez en une phrase chaque donnée",
  "myAccount.page.upload.columnDefinition.explaination.recap.understanding":
    "Il est très important que le robot comprenne quelle donnée il consulte quand il recherche un produit. Est-ce que ce sont des chiffres, des dates, un ensemble de mots, ou des colonnes de type vrai/faux ?",
  "myAccount.page.upload.columnDefinition.explaination.recap.qualityMatters":
    "Selon la qualité des informations saisies, le robot sera plus ou moins performant dans le conseil de produits.",
  "myAccount.page.upload.columnDefinition.explaination.recap.checkColumns":
    "Vérifions ensemble chaque colonne.",
  "myAccount.page.upload.columnDefinition.form.invalid":
    "Certaines colonnes n'ont pas été totalement remplies. Cherchez les champs rouges !",

  "myAccount.page.upload.columnDefinitionSetter.mandatory": "Obligatoire",
  "myAccount.page.upload.columnDefinitionSetter.mandatoryExplaination":
    "Cette colonne est obligatoire et ne peut être modifiée",
  "myAccount.page.upload.columnDefinitionSetter.emptyLine": "Ligne vide",

  "myAccount.page.upload.columnDefinition.column": "Définition de la colonne",
  "myAccount.page.upload.columnDefinition.name": "Nom pour le robot",
  "myAccount.page.upload.columnDefinition.type": "Type",
  "myAccount.page.upload.columnDefinition.semanticDescription": "Explication",

  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.name.ProductName":
    "Nom du produit",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.semanticDescription.ProductName":
    "Le nom du produit",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.name.Price":
    "Prix du produit",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.semanticDescription.Price":
    "Le prix du produit",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.name.Description":
    "Description du produit",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.semanticDescription.Description":
    "La description du produit",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.name.URLProduct":
    "URL Produit",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.semanticDescription.URLProduct":
    "Le lien URL qui permet d'accéder au produit",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.name.ImageURL":
    "URL Image Produit",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.semanticDescription.ImageURL":
    "Le lien URL qui emmène vers l'image du produit",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.name.customerProductId":
    "ID du Produit",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.semanticDescription.customerProductId":
    "L'ID unique qui permet d'identifier le produit",

  "myAccount.page.upload.columnDefinition.type.chosenType":
    "Type actuel saisi:",
  "myAccount.page.upload.columnDefinition.type.dataSample":
    "Exemple de données de cette colonne depuis vos données:",
  "myAccount.page.upload.columnDefinition.type.editType":
    "Modifier le type de la colonne:",

  "myAccount.page.upload.columnDefinition.columnNameHelper.header":
    "Plus d'informations sur le nom",
  "myAccount.page.upload.columnDefinition.columnNameHelper.intro":
    "Indiquez un nom simple, facile à comprendre, pour que le robot comprenne la donnée.",
  "myAccount.page.upload.columnDefinition.columnNameHelper.explicationOne":
    "Le nom simple, explicatif est important car il aide le robot à comprendre de quelle donnée on parle.",
  "myAccount.page.upload.columnDefinition.columnNameHelper.explicationTwo":
    "Exemples : 'jeux de société', 'nombre de joueurs' sont des noms simples. 'UK_896' n'est pas un nom simple.",

  "myAccount.page.upload.columnDefinition.columnTypeHelper.header":
    "Plus d'informations sur le type",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.explaination":
    "Préciser le type de la colonne est très important car permet au robot de savoir comment chercher.",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.intro":
    "Voici les différents types possibles:",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.enum.title":
    "Liste définie",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.enum.content":
    "Une liste définie est une liste dont on connait toutes les valeurs à l'avance. Par exemple, la taille des habits : S, XS, M, L, XL, XXL. Ou encore, des tags pour des produits - par exemple, 'Science-fiction', 'Western', 'Romance' pour des livres. C'est une liste figée, dont on connait toutes les options.",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.text.title": "Texte",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.text.content":
    "C'est la rubrique la plus commune. Pour tous textes non structurés, comme une description, une information classique.",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.number.title":
    "Chiffres et nombres",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.number.content":
    "Si la donnée est un nombre ou un chiffre. Il ne peut pas y avoir de lettre. '91' est un nombre, '91z' est un texte.",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.date.title": "Date",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.date.content":
    "Si la donnée est une date.",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.boolean.title":
    "Vrai/Faux",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.boolean.content":
    "Si la donnée est de type oui/non, ou vrai/faux. Par exemple, est-ce qu'un plat est sans gluten.",

  "myAccount.page.upload.columnDefinition.name.mandatory.isMappedTo":
    "Correspond au champs obligatoire ",

  "columnDefinition.checkbox.isRequired":
    "Cette donnée est obligatoire pour le robot",
  "columnDefinition.cta.addProperty": "Ajouter une propriété",

  "myAccount.page.upload.productDefinition.title":
    "Définition des produits du Catalogue",
  "myAccount.page.upload.productDefinition.intro":
    "Cette donnée permet au robot de comprendre vos données. Merci d’indiquer un nom court qui récapitule le type d’article que vous allez référencer dans le robot. Cette description lui servira encore une fois à être un bon vendeur dans la catégorie que vous allez indiquer. ",
  "myAccount.page.upload.productDefinition.placeholder":
    "Indiquez la catégorie de vos produits. Exemple : Smartphones",
  "myAccount.page.upload.catalog.title": "Nom du catalogue de produits",
  "myAccount.page.upload.catalog.intro":
    "Donnez un nom à votre catalogue. Ce nom ne sert que pour vous.",
  "myAccount.page.upload.catalog.placeholder": "Smartphones",

  "myAccount.page.upload.processing.singleValueError.boolean":
    "Valeur booléenne non reconnue",
  "myAccount.page.upload.processing.singleValueError.number":
    "Valeur Nombre non reconnue",
  "myAccount.page.upload.processing.singleValueError.date":
    "Valeur Date non reconnue",
  "myAccount.page.upload.processing.singleValueError.text":
    "Valeur Text non reconnue",
  "myAccount.page.upload.processing.singleValueError.enum":
    "Valeur Enum non reconnue",
  "myAccount.page.upload.processing.singleValueError.url":
    "Valeur Url non reconnue. Doit commencer par 'http'",
  "myAccount.page.upload.processing.lineError":
    "Ligne: {indexProduct} - Erreur pendant le parsing : Proriété: {property} / Valeur reçue: {value}",
  "myAccount.page.upload.processing.notHandledError":
    "Ligne: {indexProduct} - Donnée non gérée: Propriété - {property} / Valeur reçue : {value}",

  "myAccount.page.upload.error.intro":
    "Il y a des erreurs lors du traitement de votre fichier.",
  "myAccount.page.upload.error.explaination":
    "Chaque ligne avec une erreur est affichée ci-dessous. Merci de vérifier le contenu correspondant et de le corriger. Vous pourrez ensuite réuploader le fichier (vos paramètres saisis ne sont pas perdus)",
  "myAccount.page.upload.button.cta": "Upload",
  "myAccount.page.upload.success.notification":
    "Votre fichier a été correctement uploadé.",
  "myAccount.page.upload.failure.notification":
    "Votre fichier n'a pu être uploadé. Merci de corriger les erreurs affichées dans votre fichier et/ou dans la définition des colonnes, et de réessayer.",
  "myAccount.page.upload.failure.restartUpload": "Restart",

  "myAccount.page.upload.success.component.title": "Succès",
  "myAccount.page.upload.success.component.explaination":
    "Votre fichier a été correctement uploadé.",
  "myAccount.page.upload.success.component.explaination2":
    "Les produits s'afficheront désormais dans les résultats du chatbot à vos clients.",

  "myAccount.page.upload.columnDefinition.columnTypeSemanticDescription.header":
    "Plus d'informations sur la description",
  "myAccount.page.upload.columnDefinition.columnTypeSemanticDescription.explanaitionOne":
    "Exliquez en une phrase ce que contient cette colonne, de façon simple, qu'un ami comprendrait.",
  "myAccount.page.upload.columnDefinition.columnTypeSemanticDescription.explanaitionTwo":
    "Exemple : une colonne avec un nom 'durée du jeu' pourrait contenir la phrase suivante : 'La durée de jeu souhaitée par le client'",
  "myAccount.page.upload.columnDefinition.columnTypeSemanticDescription.explanaitionThree":
    "Les colonnes de type vrai/faux doivent être une question. Exemple : 'ce plat est-il sans gluten ?'",

  "myAccount.page.myCatalogs.catalog.title": "Catalogue",
  "myAccount.page.myCatalogs.catalog.name": "Nom",
  "myAccount.page.myCatalogs.catalog.isDefault": "Est par défaut",
  "myAccount.page.myCatalogs.catalog.default": "Défaut",
  "myAccount.page.myCatalogs.catalog.productDefinition":
    "Définition des produits du catalogue",
  "myAccount.page.myCatalogs.catalog.delete": "Supprimer le catalogue",
  "myAccount.page.myCatalogs.catalog.delete.success":
    "Le catalogue a bien été effacé.",
  "myAccount.page.myCatalogs.catalog.products.delete.cta":
    "Effacer les produits du catalogue",
  "myAccount.page.myCatalogs.catalog.products.delete.success":
    "Les produits du catalogue ont été effacés.",
  "myAccount.page.myCatalogs.catalog.numberOfProducts": "Nombre de produits : ",
  "myAccount.page.myCatalogs.all.noCatalogs":
    "Vous n'avez pas de catalogue pour l'instant.",
  "myAccount.page.myCatalogs.cta.create": "Créer un catalogue",
  "myAccount.page.myCatalogs.cta.save": "Sauvegarder le catalogue",
  "myAccount.page.myCatalogs.save.success": "Votre catalogue a bien été créé.",
  "myAccount.page.myCatalogs.save.error":
    "Il y a eu une erreur lors de la création de votre catalogue. Merci de contacter le support.",
  "myAccount.page.myCatalogs.creation.success.title": "Succès",
  "myAccount.page.myCatalogs.creation.success.explaination":
    "Votre catalogue a bien été créé.",
  "myAccount.page.myCatalogs.creation.success.explaination2":
    "Vous pouvez maintenant uploader des produits afin que votre agent chatbot les présente.",
  "myAccount.page.myCatalogs.edition.save.cta": "Sauvegarder les modifications",
  "myAccount.page.myCatalogs.edition.searchFilter.edit.cta":
    "Modifier les filtres de recherche",
  "myAccount.page.myCatalogs.edition.searchFilter.save.cta":
    "Sauvegarder les filtres de recherche",
  "myAccount.page.myCatalogs.searchFiltersedition.title":
    "Modifier les filtres de recherche",
  "myAccount.page.myCatalogs.edition.save.success":
    "Votre catalogue a bien été modifié.",
  "myAccount.page.myCatalogs.searchFiltersedition.save.success":
    "Vos filtres de recherche ont bien été modifiés.",
  "myAccount.page.myCatalogs.searchFiltersedition.edit.notIfProductsExist":
    "Vous ne pouvez pas modifier les filtres de recherche d'un catalogue contenant des produits existants. Videz le catalogue de tous ses produits avant de le modifier.",

  "myAccount.page.myAgents.cta.save": "Enregistrer",
  "myAccount.page.myAgents.cta.title": "Modifier Agent",
  "myAccount.page.myAgents.cta.field.name": "Nom",
  "myAccount.page.myAgents.cta.field.startingText":
    "Texte de départ du chatbot",

  "myAccount.page.myDNS.intro":
    "Gérez ici l'ensemble des noms de domaine autorisés pour votre agent",
  "myAccount.page.myDNS.CTA.addNewDNS": "Ajouter un nouveau domaine",
  "myAccount.page.myDNS.CTA.save": "Sauvegarder",
  "myAccount.page.myDNS.save.success":
    "Les noms de domaine autorisés ont bien été mis à jour",
  "myAccount.page.myDNS.save.failure":
    "Les noms de domaine n'ont pas pu être mis à jour. Merci de contacter le support.",

  "myAccount.page.profile.title": "Mes informations",
  "myAccount.page.profile.company.name.title": "Nom de votre entreprise",
  "myAccount.page.profile.company.name.monthlyMaxBudget":
    "Budget mensuel maximum (Laisser vide pour ne pas bloquer)",
  "myAccount.page.profile.company.placeholder":
    "Ajoutez le nom de votre entreprise",
  "myAccount.page.profile.company.cannotEditMaxBudget":
    "Votre formule ayant un seuil fixe de dépense, vous ne pouvez modifier ce champs.",

  "myAccount.page.profile.company.save.success":
    "Votre entreprise a bien été mise à jour",
  "myAccount.page.company.save.failure":
    "Votre entreprise n'a pas pu être mis à jour. Merci de contacter le support.",

  "myAccount.page.myUserSessions.all.table.title": "Discussions Utilisateurs",
  "myAccount.page.myUserSessions.all.table.id": "Id",
  "myAccount.page.myUserSessions.all.table.agent": "Agent",
  "myAccount.page.myUserSessions.all.table.numberOfMessages":
    "Nombre de messages",
  "myAccount.page.myUserSessions.all.table.Totalduration": "Durée totale",
  "myAccount.page.myUserSessions.all.table.TFTduration": "Durée TFT",
  "myAccount.page.myUserSessions.all.table.COT": "COT",
  "myAccount.page.myUserSessions.all.table.LastUse": "Création",
  "myAccount.page.myUserSessions.all.noUserSession":
    "Vous n'avez pas de discussion utilisateur pour l'instant.",

  "admin.page.companies.all.table.title": "Sociétés",
  "admin.page.companies.all.table.id": "Id",
  "admin.page.companies.all.table.name": "Nom",
  "admin.page.companies.all.table.mail": "Mail",
  "admin.page.companies.all.noCompanies":
    "Il n'y a pas de société pour l'instant.",
  "admin.page.companies.crud.create": "Créer une société",
  "admin.page.companies.crud.edit.title": "Editer une société",
  "admin.page.companies.crud.edit.agentsDisplayed.title":
    "Agents de la société",
  "admin.page.companies.crud.create.success":
    "La société a été créée avec succès.",
  "admin.page.companies.crud.update.success":
    "La société a été éditée avec succès.",

  "admin.page.users.all.table.title": "Utilisateurs",
  "admin.page.users.all.table.id": "Id",
  "admin.page.users.all.table.name": "Nom",
  "admin.page.users.all.table.mail": "Mail",
  "admin.page.users.all.noUsers": "Il n'y a pas d'utilisateur pour l'instant.",
  "admin.page.users.crud.edit.title": "Editer Utilisateur",
  "admin.page.users.crud.update.success":
    "L'utilisateur a été mis à jour avec succès",

  "admin.page.agents.all.table.title": "Agents",
  "admin.page.agents.all.table.id": "Id",
  "admin.page.agents.all.table.name": "Nom",
  "admin.page.agents.all.table.isDefault": "Par défaut",
  "admin.page.agents.all.table.commpanyId": "Company Id",
  "admin.page.agents.all.noAgents": "Il n'y a pas d'agent pour l'instant",
  "admin.page.agents.crud.edit.title": "Editer un agent",
  "admin.page.agents.crud.update.success":
    "L'agent a été mis à jour avec succès",

  "admin.page.catalogs.all.table.title": "Catalogues",
  "admin.page.catalogs.all.table.id": "Id",
  "admin.page.catalogs.all.table.name": "Nom",
  "admin.page.catalogs.all.nocatalogs":
    "Il n'y a pas de catalogues pour l'instant",
  "admin.page.companies.crud.edit.catalogDisplayed.title":
    "Catalogues de l'agent",
  "admin.page.catalogs.crud.edit.title": "Editer un catalogue",
  "admin.page.catalogs.crud.update.success":
    "Le catalogue a été mis à jour avec succès",

  "myAccount.page.oneSession.title": "Discussion Utilisateur",
  "myAccount.page.oneSession.": "Discussion Utilisateur",

  "myAccount.page.myChatbot.errorBlockingAgentDisplay":
    "Certaines erreurs empêchent le chatbot de s'afficher.",
  "myAccount.page.myChatbot.noSearchFilter.title": "Pas de filtre de recherche",
  "myAccount.page.myChatbot.noSearchFilter":
    "Vous n'avez pas configuré de filtres de recherche pour votre catalogue. Il ne peut donc pas utiliser de critères de recherche. Merci de les mettre en place.",
  "myAccount.page.myChatbot.noProducts.title": "Pas de produits",
  "myAccount.page.myChatbot.noProducts":
    "Vous n'avez ajouté aucun produit pour votre chatbot. Cela signifie qu'il ne peut rien proposer. Merci de les ajouter.",
  "myAccount.page.myChatbot.noCatalogs.title": "Pas de catalogue",

  "myAccount.page.myChatbot.noCatalogs":
    "Vous n'avez aucun catalogue de produits pour votre chatbot. Cela signifie qu'il ne peut rechercher quoi que ce soit. Merci d'en créer au moins un, de lui ajouter des filtres de recherche, et d'ajouter les produits.",

  "admin.page.leftMenu.entity": "Entités",
  "admin.page.leftMenu.workflow": "Workflow",
  "admin.page.leftMenu.entities.companies": "Sociétés",
  "admin.page.leftMenu.entities.agents": "Agents",
  "admin.page.leftMenu.entities.users": "Utilisateurs",
  "admin.page.leftMenu.entities.catalogs": "Catalogues",
  "admin.page.leftMenu.workflow.onboard": "Onboard Manuel",

  "admin.session.cost": "Coût (centimes)",
  "admin.session.oneSession.cost": "Coût (centimes)",
  "admin.session.oneSession.message.functionUsed": "Fonction: ",
  "admin.session.oneSession.message.model": "Modèle: ",
  "admin.session.oneSession.message.provider": "Provider: ",
  "admin.session.oneSession.message.duration": "Durée: ",
  "admin.session.oneSession.message.cost": "Coût (centimes)",
  "admin.subscriptionFormula.add": "Créer",
  "admin.subscriptionFormula.id": "Id",
  "admin.subscriptionFormula.fixedPrice": "Prix de base",
  "admin.subscriptionFormula.BSPriceResell": "tarif User Discussion",
  "admin.subscriptionFormula.isDisplayedOnFrontEnd": "Visible Front",
  "admin.subscriptionFormula.subscriptionType": "Type de Subscription",
  "admin.subscriptionFormula.noOne":
    "Il n'existe pas de formules d'abonnement pour l'instant",
  "admin.subscriptionFormula.page.create.title":
    "Créer une nouvelle Formule d'abonnement",

  "chatbot.placeholder.content": "Envoyez un message à l'assistant ...",
  "chatbot.chatline.label.user": "Vous",
  "chatbot.chatline.label.assistant": "Assistant",
  "chatbot.chatline.loading.function.search": "Recherche",
  "chatbot.chatline.loading.function.genericSearchMessage":
    "Je cherche des produits",
  "chatbot.chatline.loading.function.extractProductName":
    "Recherche dans la caverne",
  "chatbot.chatline.loading.function.suggestProductName":
    "Consultation des shadocks",
  "chatbot.chatline.loading.function.criteriaDefinition":
    "Recherche des ziboublis",
  "chatbot.chatline.loading.function.searchStock": "Recherche en stock",
  "chatbot.chatline.loading.function.step": "Etape",

  "footer.tab.title.general": "Général",
  "footer.tab.title.about": "A propos",
  "footer.tab.title.resources": "Ressources",
  "footer.tab.title.legal": "Mentions Légales",
  "footer.tab.title.social": "Social",
  "footer.tab.title.articles": "Articles",
  "footer.tab.title.chatbot": "Chatbot",
  "footer.tab.title.data_augmentation": "Augmentation de données",
  "footer.tab.search": "Rechercher",
  "footer.tab.pricing": "Tarifs",
  "footer.tab.termsAndConditions": "Termes et conditions",
  "footer.tab.documentation": "Documentation",
  "footer.tab.finalCopyright":
    "Copyright © 2025 Logiciel, Inc. Tous droits réservés.",
};
